// @flow
import styled from 'styled-components'

export const FormStyle = styled.form`
  min-width: 375px;
  max-width: 550px;
`
